<img src="/assets/images/file.svg" width="30" height="30" alt="" />
<span class="file-type-text">{{ fileTypeText }}</span>
